import { oc } from "@orpc/contract";
import { z } from "zod";

const driftCandidateSchema = z.object({
  kind: z.enum(["table", "column", "enum", "index"]),
  /** Table name, `table.column`, or enum type name. Also the selection key. */
  id: z.string(),
  table: z.string().optional(),
  column: z.string().optional(),
  /** Rows for a table, non-null values for a column, dependents for an enum. */
  usage: z.number(),
  /** False when dropping it would destroy data that is still there. */
  safeToDrop: z.boolean(),
  detail: z.string(),
});

export const schemaDriftContracts = {
  /** Read-only. Everything this database holds that the migrations never create. */
  findSchemaDrift: oc
    .input(z.object({}))
    .output(
      z.object({
        candidates: z.array(driftCandidateSchema),
      }),
    )
    .route({
      summary: "Find database objects not created by migrations",
      description:
        "Admin only, read-only. Lists tables, columns, enums and indexes present in the database but absent from migrations, with data usage and drop safety.",
    }),

  /**
   * Drops the selected objects. Every one is re-checked against the database
   * first, because a selection is made against a report read some time ago.
   */
  dropSchemaDrift: oc
    .input(
      z.object({
        ids: z.array(z.string()).min(1),
        /** Defaults to a dry run: the caller has to ask for the destructive path. */
        dryRun: z.boolean().default(true),
      }),
    )
    .output(
      z.object({
        outcomes: z.array(
          z.object({
            id: z.string(),
            dropped: z.boolean(),
            reason: z.string().optional(),
          }),
        ),
      }),
    )
    .route({
      summary: "Drop database objects not created by migrations",
      description:
        "Admin only. Re-checks then drops the selected untracked tables, columns, enums or indexes; defaults to a dry run reporting what would be dropped.",
    }),
};
